export const identify = 'identify',
             pageViewed = 'pageViewed',
             productListViewed = 'productListViewed',
             productClicked = 'productClicked',
             productViewed = 'productViewed',
             productAdded = 'productAdded',
             productRemoved = 'productRemoved',
             promotionViewed = 'promotionViewed',
             promotionClick = 'promotionClick',
             cartViewed = 'cartViewed',
             gtmStart = 'gtmStart',
             cartDetailEvent = 'cartDetailEvent',
             checkoutStep = 'checkoutStep',
             checkoutStepViewed = 'checkoutStepViewed',
             checkoutStepViewedPayment = 'checkoutStepViewedPayment',
             orderCompleted = 'orderCompleted',
             loginAction = 'loginAction',
             signUpAction = 'signUpAction';
